import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const STORAGE_KEY = "frontera_attribution";

/**
 * Captures referral/UTM params from URL, persists them to localStorage,
 * and attributes the user when they authenticate.
 *
 * URL format (set by /api/share/{type}/{id}): ?ref_type=...&ref_id=...&utm_source=...&utm_campaign=...
 */
export const AttributionTracker = () => {
  const location = useLocation();
  const { user } = useAuth();

  // 1. Capture ref params from URL
  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    const ref_type = qs.get("ref_type");
    const ref_id = qs.get("ref_id");
    if (!ref_type || !ref_id) return;

    const data = {
      entity_type: ref_type,
      entity_id: ref_id,
      utm_source: qs.get("utm_source") || null,
      utm_medium: qs.get("utm_medium") || null,
      utm_campaign: qs.get("utm_campaign") || null,
      captured_at: new Date().toISOString(),
    };
    try {
      // Only set if not already attributed on this device
      if (!localStorage.getItem(STORAGE_KEY)) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      }
    } catch {
      /* ignore */
    }
  }, [location.search]);

  // 2. When user authenticates, attribute them
  useEffect(() => {
    if (!user) return;
    let raw;
    try {
      raw = localStorage.getItem(STORAGE_KEY);
    } catch {
      return;
    }
    if (!raw) return;
    let data;
    try {
      data = JSON.parse(raw);
    } catch {
      localStorage.removeItem(STORAGE_KEY);
      return;
    }
    api
      .post("/share/attribute", {
        entity_type: data.entity_type,
        entity_id: data.entity_id,
        utm_source: data.utm_source,
        utm_medium: data.utm_medium,
        utm_campaign: data.utm_campaign,
      })
      .then(() => {
        localStorage.removeItem(STORAGE_KEY);
      })
      .catch(() => {
        /* already attributed or network error */
      });
  }, [user]);

  return null;
};
